import { useMemo, useState } from 'react';
/**
 * A hook that handles persisting instrument settings to be included in the API
 * request, that are not persisted in the global settings state.
 *
 * These settings are scoped and applied on each individual panel, while the
 * global settings are applied to all panels in a dashboard, and they are
 * typically instrument-specific settings such as chart granularity, which when
 * changed trigger a new API request.
 */
export const usePersistInstrumentSettings = () => {
    const [instrumentSettings, setInstrumentSettings] = useState();
    return useMemo(() => ({ instrumentSettings, setInstrumentSettings }), [instrumentSettings, setInstrumentSettings]);
};
